const styles = {
  companiesMenuItems: { display: 'flex', justifyContent: 'space-between' },
};

export default styles;
